// 所有删除走这个接口.有弹窗.有确实
import Vue from "vue";
// 外面其实有引用的
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { http } from '@/utils/http.js';
/**
 * @param {Object} deleteAbout //删除API相关信息。url，方式，id
 * @param {Function} cb //回调函数
 * @param {String} name //项目名
 * @return {Promise} //返回一个promise
 */
Vue.prototype.$deleteFuc = (deleteAbout = { deleteUrl: '', deleteId: 0, APImethod: 'delete', data: { ids: 10 } }, cb = null, name = '该项目', ) => {
    return Dialog.confirm({
        title: '确认删除吗？',
        message: `确定将${name}删除吗？`
    }).then(() => {
        let loadingToast = Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '处理中',
            mask: true
        });
        http({
            url: deleteAbout.deleteUrl,
            method: deleteAbout.APImethod || 'delete',
            // 因为key值可能不同
            data: deleteAbout.data
        }).then(res => {
            loadingToast.clear();
            Toast.success('删除成功');
            cb && cb();
        }).catch(err => {
            Toast.fail('删除失败');
        })
    })
}

/**
 * @param {Object} baseAbout //基础信息
 * @param {Object} APIAbout //API相关信息。url，方式，id
 * @param {Object} cbAbout //回调函数
 * @return {Promise} //返回一个promise
 */
const baseInfoConfig = {
    isEdit: true,
    name: '改项目', //默认名称
}
const APIConfig = {
    url: '',
    method: 'post',
    data: {}
}
const cbConfig = {
    success: () => { },
    catch: () => { },
    finally: () => { }
}
Vue.prototype.$editFuc = (baseAbout = {}, APIAbout = {}, cbAbout = {}) => {
    let baseInfo = Object.assign(baseInfoConfig, baseAbout);
    let APIinfo = Object.assign(APIConfig, APIAbout);
    let cbInfo = Object.assign(cbConfig, cbAbout);
    return Dialog.confirm({
        title: `确认${baseInfo.isEdit ? '修改' : '新增'}吗？`,
        message: `确定${baseInfo.isEdit ? '修改' : '新增'}${baseInfo.name}项目的吗？`
    }).then(() => {
        let loadingToast = Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '提交中',
            mask: true
        });
        http({
            url: APIinfo.url,
            method: APIinfo.method,
            // 因为key值可能不同
            data: APIinfo.data
        })
            .then(res => {
                loadingToast.clear();
                Toast.success(`${baseInfo.isEdit ? '修改' : '新增'}成功`);
                cbInfo.success && cbInfo.success();
                // this.$emit('changeProgress');
            })
            .catch(err => {
                Toast.fail(`${baseInfo.isEdit ? '修改' : '新增'}失败`);
            }).finally(res => {
                cbInfo.finally && cbInfo.finally();
            })
    })
}

Vue.prototype.$gisConverter = {
    PI: 3.14159265358979324,
    x_pi: 3.14159265358979324 * 3000.0 / 180.0,
    delta: function (lat, lon) {
        // Krasovsky 1940
        //
        // a = 6378245.0, 1/f = 298.3
        // b = a * (1 - f)
        // ee = (a^2 - b^2) / a^2;
        var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
        var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
        var dLat = this.transformLat(lon - 105.0, lat - 35.0);
        var dLon = this.transformLon(lon - 105.0, lat - 35.0);
        var radLat = lat / 180.0 * this.PI;
        var magic = Math.sin(radLat);
        magic = 1 - ee * magic * magic;
        var sqrtMagic = Math.sqrt(magic);
        dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
        dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
        return { 'lat': dLat, 'lon': dLon };
    },

    //GPS---高德
    gcj_encrypt: function (wgsLat, wgsLon) {
        if (this.outOfChina(wgsLat, wgsLon))
            return { 'lat': wgsLat, 'lon': wgsLon };

        var d = this.delta(wgsLat, wgsLon);
        return { 'lat': wgsLat + d.lat, 'lon': wgsLon + d.lon };
    },
    outOfChina: function (lat, lon) {
        if (lon < 72.004 || lon > 137.8347)
            return true;
        if (lat < 0.8293 || lat > 55.8271)
            return true;
        return false;
    },
    transformLat: function (x, y) {
        var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
        return ret;
    },
    transformLon: function (x, y) {
        var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
        return ret;
    }
};





// WEBPACK FOOTER //
// ./src/globalFuc/operate.js